import { HolderOutlined } from "@ant-design/icons";
import { Checkbox, Modal } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { SortableList } from "src/components/SortableList";

import { RtCtrlColumnsSettings } from "../../ctrl";
import { isColumnConfigurable } from "../../RtColumn";
import { applyColumnsOrder } from "../../utils/applyColumnsOrder";
import * as styles from "./RtColumnsSettingsModal.module.less";

const freezeKey = "~fixedLeft";

type PropsRtColumnsSettingsModal = {
  open: boolean;
  close: () => void;
  store: RtCtrlColumnsSettings;
};

export const RtColumnsSettingsModal: React.FC<PropsRtColumnsSettingsModal> =
  observer((props) => {
    const { open, close, store } = props;
    const { hiddenColumnKeys } = store;

    const onNewOrder = (keys: string[]) => {
      const freezePos = keys.findIndex((key) => key === freezeKey);
      if (freezePos >= 0) {
        keys.splice(freezePos, 1);
      }
      store.changeColumnsOrder(keys);
      if (freezePos >= 0) {
        store.setFixedLeftRaw(freezePos);
      }
    };

    const columns = applyColumnsOrder(
      store.srcColumns.filter(isColumnConfigurable),
      store.columnsOrder,
    );
    const sortableItems = columns.map(({ key, shortTitle, title }) => ({
      key,
      content: (
        <>
          <div className={styles.checker}>
            <Checkbox
              checked={!hiddenColumnKeys.has(key)}
              onChange={(e) => {
                store.changeColumnVisibility(key, e.target.checked);
              }}
              disabled={!store.canColumnHide(key)}
              style={{ width: "100%" }}
            >
              {shortTitle || title}
            </Checkbox>
          </div>
          <HolderOutlined />
        </>
      ),
    }));

    const key = freezeKey;
    const freezePos = store.fixedLeftRaw;
    sortableItems.splice(freezePos, 0, {
      key,
      content: (
        <div key={key} className={styles.freezeContainer}>
          <div className={styles.freezeLabel}>Freeze Line</div>
          <div className={styles.freezeLine} />
          <HolderOutlined />
        </div>
      ),
    });

    return (
      <Modal
        open={open}
        onCancel={close}
        title="Настройка столбцов таблицы"
        centered
        footer={null}
      >
        <div className={styles.content}>
          <SortableList
            containerClass={styles.list}
            itemClass={styles.item}
            onChange={onNewOrder}
            items={sortableItems}
          />
        </div>
      </Modal>
    );
  });
